document.addEventListener('DOMContentLoaded', function () {
  var fills = document.querySelectorAll('.sh-performance-fill');

  function animateFill(fill) {
    var target = fill.getAttribute('data-target');
    if (!target) return;
    requestAnimationFrame(function () {
      fill.style.width = target + '%';
    });
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateFill(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.25 });

    fills.forEach(function (fill) {
      observer.observe(fill);
    });
  } else {
    fills.forEach(function (fill) {
      animateFill(fill);
    });
  }
});